import {CheckCircleIcon} from '@primer/octicons-react'
import {useSuspenseActivityPageData} from '../../data/use-activity-page-data'
import {SidebarActivityRow} from './SidebarActivityRow'
import {hasApprovals, pluralize, sumReviewComments} from './activity-row-helpers'

export function ApprovedRow() {
  const {summary} = useSuspenseActivityPageData()
  if (!hasApprovals(summary)) return null

  const count = summary?.approvals?.count ?? 0
  const comments = sumReviewComments(summary?.approvals?.events ?? [])
  const label =
    comments > 0
      ? `${count} approved with ${comments} ${pluralize(comments, 'comment', 'comments')}`
      : `${count} approved`

  return (
    <SidebarActivityRow
      icon={CheckCircleIcon}
      categoryLabel="Approvals"
      label={label}
      group="approvals"
      expectedCount={count}
    />
  )
}
